import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { NotReadyBadge, NotReadyNote } from './FinanceNotReady';

/** Figma / Confluence Refunds & Chargebacks chart — shell until refund schema. */
export function RefundsChargebacksCard() {
  return (
    <Card className="shadow-none">
      <CardHeader className="space-y-1 p-5 pb-2">
        <div className="flex flex-wrap items-center gap-2">
          <CardTitle className="text-sm font-medium text-sky-400">Refunds & Chargebacks</CardTitle>
          <NotReadyBadge
            state="not-ready"
            reason="Refund and chargeback event tables are not wired. This module unlocks in Phase 4 and then feeds Net Settlement adjustments."
          />
        </div>
        <p className="text-[11px] text-muted-foreground">
          Combined daily total and trend. Separate refund vs chargeback rates are not required yet.
        </p>
      </CardHeader>
      <CardContent className="space-y-3 p-5 pt-2">
        <div className="flex h-56 items-center justify-center rounded-md border border-dashed border-border/70 bg-muted/20 px-4 text-center text-xs text-muted-foreground">
          Chart not ready
        </div>
        <NotReadyNote>
          Refund / chargeback event tables are not wired. This module unlocks in Phase 4 and then
          feeds Net Settlement adjustments.
        </NotReadyNote>
      </CardContent>
    </Card>
  );
}
